import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Container from "../ui/Container";
import SectionHeading from "../ui/SectionHeading";
import SmartImage from "../ui/SmartImage";
import brand1 from "../../assets/brand1.png";
import brand2 from "../../assets/brand2.png";
import brand3 from "../../assets/brand3.png";
import brand4 from "../../assets/brand4.png";
import brand5 from "../../assets/brand5.png";

const brands = [brand1, brand2, brand3, brand4, brand5];

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false,
  responsive: [
    { breakpoint: 768, settings: { slidesToShow: 3 } },
    { breakpoint: 480, settings: { slidesToShow: 2 } },
  ],
};

const Partners = () => (
  <section className="bg-surface-container-low py-20">
    <Container>
      <SectionHeading align="center" title="Our Partners" className="mb-12" />
      <Slider {...settings}>
        {brands.map((brand, index) => (
          <div key={index} className="px-3">
            <div className="flex h-24 items-center justify-center rounded-xl border border-outline-variant/30 bg-inverse-surface p-6 shadow-sm">
              <SmartImage
                src={brand}
                alt={`Partner ${index + 1}`}
                wrapperClassName="rounded-md"
                className="max-h-12 w-auto object-contain"
              />
            </div>
          </div>
        ))}
      </Slider>
    </Container>
  </section>
);

export default Partners;
